var SVGIcons = /* @__PURE__ */ ((SVGIcons2) => {
  SVGIcons2["analyticsPie"] = "AnalyticsPie";
  SVGIcons2["currency"] = "SvgCurrency";
  SVGIcons2["city"] = "SvgCity";
  SVGIcons2["cricket"] = "Cricket";
  SVGIcons2["downloadIcon"] = "SvgDownload";
  SVGIcons2["email"] = "SvgEmail";
  SVGIcons2["error"] = "SvgError";
  SVGIcons2["errorSecond"] = "SvgErrorSecond";
  SVGIcons2["loader"] = "SvgInputLoader";
  SVGIcons2["flag"] = "SvgFlag";
  SVGIcons2["lock"] = "SvgLock";
  SVGIcons2["name"] = "SvgName";
  SVGIcons2["postcode"] = "SvgPostcode";
  SVGIcons2["eye"] = "SvgSee";
  SVGIcons2["street"] = "SvgStreet";
  SVGIcons2["success"] = "SvgTick";
  SVGIcons2["close"] = "SvgClose";
  SVGIcons2["closeSecondary"] = "SvgCloseSecondary";
  SVGIcons2["not_found"] = "SvgLook";
  SVGIcons2["not_found_modern"] = "NotFoundModern";
  SVGIcons2["deposit"] = "SvgDeposit";
  SVGIcons2["withdrawal"] = "SvgWithdrawal";
  SVGIcons2["transaction"] = "SvgTransaction";
  SVGIcons2["preferences"] = "SvgPreferences";
  SVGIcons2["casino"] = "Roulette";
  SVGIcons2["sport"] = "Ball";
  SVGIcons2["books"] = "SvgBook";
  SVGIcons2["pending"] = "SvgPending";
  SVGIcons2["notice"] = "SvgNotice";
  SVGIcons2["star"] = "SvgStar";
  SVGIcons2["find"] = "SvgFind";
  SVGIcons2["find_color"] = "SvgFindColor";
  SVGIcons2["arrow"] = "SvgArrow";
  SVGIcons2["casino_popular"] = "SvgCasinoPopular";
  SVGIcons2["casino_halloween"] = "SvgCasinoHalloween";
  SVGIcons2["casino_new_games"] = "SvgCasinoNewGames";
  SVGIcons2["casino_favorites"] = "SvgCasinoFavorites";
  SVGIcons2["casino_slots"] = "SvgCasinoSlots";
  SVGIcons2["casino_roulette"] = "SvgCasinoRoulette";
  SVGIcons2["casino_blackjack"] = "SvgCasinoBlackjack";
  SVGIcons2["casino_baccarat"] = "SvgCasinoBaccarat";
  SVGIcons2["casino_all"] = "SvgCasinoAll";
  SVGIcons2["casino_lobby"] = "SvgCasinoLobby";
  SVGIcons2["casino_jackpots"] = "SvgCasinoJackpots";
  SVGIcons2["casino_bonus_buy"] = "SvgCasinoBonusBuy";
  SVGIcons2["casino_jackpot"] = "SvgCasinoJackpot";
  SVGIcons2["casino_other"] = "SvgCasinoOther";
  SVGIcons2["casino_poker"] = "SvgCasinoPoker";
  SVGIcons2["casino_recommended"] = "SvgCasinoRecommended";
  SVGIcons2["delete"] = "SvgDelete";
  SVGIcons2["hot"] = "SvgCasinoHot";
  SVGIcons2["casino_drops_and_wins"] = "SvgCasinoDropsAndWins";
  SVGIcons2["casino_fast_games"] = "SvgCasinoFastGames";
  SVGIcons2["livecasino_all"] = "SvgLivecasinoAll";
  SVGIcons2["livecasino_lobby"] = "SvgLivecasinoLobby";
  SVGIcons2["fullSize"] = "SvgFullSize";
  SVGIcons2["watchersChat"] = "SvgWatchersChat";
  SVGIcons2["watchersClose"] = "SvgWatchersClose";
  SVGIcons2["christ_bold"] = "SvgChristBold";
  SVGIcons2["successMark"] = "SvgSuccessMark";
  SVGIcons2["coeffDisabled"] = "SvgCoeffDisabled";
  SVGIcons2["baseArrow"] = "BaseArrow";
  SVGIcons2["factorStats"] = "SvgFactorStats";
  SVGIcons2["ballLoader"] = "SvgBallLoader";
  SVGIcons2["starFilled"] = "SvgStarFilled";
  SVGIcons2["starColourfull"] = "SvgStarColourfull";
  SVGIcons2["starFilledForecasts"] = "SvgStarFilledForecasts";
  SVGIcons2["factorAdditional"] = "FactorAdditionalUp";
  SVGIcons2["basket"] = "SvgBasket";
  SVGIcons2["sportFilterPopular"] = "SvgFilterPopular";
  SVGIcons2["sportFilterAZ"] = "SvgFilterAz";
  SVGIcons2["sportFilterCountry"] = "SvgFilterCountry";
  SVGIcons2["bonusSport"] = "SvgBonusSport";
  SVGIcons2["bonusSportTwo"] = "SvgBonuSportTwo";
  SVGIcons2["bonusCasino"] = "SvgBonusCasino";
  SVGIcons2["bonusCasinoTwo"] = "SvgBonusCasinoTwo";
  SVGIcons2["restricted"] = "SvgNoBonus";
  SVGIcons2["restrictedTwo"] = "SvgNoBonusTwo";
  SVGIcons2["recentlyPlayed"] = "RecentlyPlayed";
  SVGIcons2["activeEye"] = "SvgEyeActive";
  SVGIcons2["login"] = "SvgLogin";
  SVGIcons2["footBall"] = "IconFootball";
  SVGIcons2["ios"] = "Ios";
  SVGIcons2["android"] = "Android";
  SVGIcons2["home"] = "SvgHome";
  SVGIcons2["liveCasino"] = "Cards";
  SVGIcons2["logout"] = "SvgCloseIcon";
  SVGIcons2["autoPick"] = "SvgAutoPick";
  SVGIcons2["bonuses"] = "SvgBonuses";
  SVGIcons2["betHistory"] = "SvgBetHistory";
  SVGIcons2["forecastHistory"] = "SvgForecastHistory";
  SVGIcons2["casinoHistory"] = "SvgCasinoHistory";
  SVGIcons2["jackpotHistory"] = "SvgJackpotHistory";
  SVGIcons2["ic_promotionsCasino"] = "SvgCasinoPromotions";
  SVGIcons2["ic_score"] = "SvgScore";
  SVGIcons2["ic_betradar"] = "SvgBetradar";
  SVGIcons2["ticket"] = "SvgTicket";
  SVGIcons2["trashbin"] = "SvgTrashbin";
  SVGIcons2["flash"] = "SvgFlash";
  SVGIcons2["my_bets"] = "SvgMyBets";
  SVGIcons2["sort"] = "SvgSort";
  SVGIcons2["wallet"] = "SvgWallet";
  SVGIcons2["plus_deposit"] = "SvgPlusDeposit";
  SVGIcons2["betslipArrow"] = "SvgBetslipArrow";
  SVGIcons2["betslipReturn"] = "SvgBetslipArrowReturn";
  SVGIcons2["betslipClear"] = "SvgBetslipClear";
  SVGIcons2["ic_live"] = "SvgLive";
  SVGIcons2["ic_casino"] = "SvgCasino";
  SVGIcons2["ic_livecasino"] = "SvgLivecasino";
  SVGIcons2["ic_promo"] = "SvgPromo";
  SVGIcons2["ic_jackpot"] = "SvgJackpot";
  SVGIcons2["ic_forecast"] = "SvgForecast";
  SVGIcons2["ic_results"] = "SvgResults";
  SVGIcons2["calendar"] = "SvgCalendar";
  SVGIcons2["ic_name"] = "SvgNameNew";
  SVGIcons2["ic_bets"] = "SvgBets";
  SVGIcons2["ic_cashier"] = "SvgCashier";
  SVGIcons2["ic_account"] = "SvgAccount";
  SVGIcons2["ic_promotion"] = "SvgPromotion";
  SVGIcons2["ic_notification"] = "SvgNotification";
  SVGIcons2["eventArrow"] = "SvgEventArrow";
  SVGIcons2["mobBetSlip"] = "IconMobBetslip";
  SVGIcons2["ic_promo_ball"] = "Ball";
  SVGIcons2["ic_promo_roullete"] = "Roulette";
  SVGIcons2["ic_gift"] = "SvgGift";
  SVGIcons2["ic_login"] = "SvgLoginArrow";
  SVGIcons2["info"] = "IcInfo";
  SVGIcons2["info_circle"] = "InfoCircle";
  SVGIcons2["question_in_circle"] = "SvgQuestionInCircle";
  SVGIcons2["ic_settings"] = "SvgSettings";
  SVGIcons2["navBurger"] = "SvgNavBurger";
  SVGIcons2["casinoMainIcon"] = "CasinoIconNew";
  SVGIcons2["sportCasino"] = "IconSportCasino";
  SVGIcons2["mainBannerLineLeft"] = "IconMainBannerLineLeft";
  SVGIcons2["mainBannerLineRight"] = "IconMainBannerLineRight";
  SVGIcons2["coin"] = "IconCoin";
  SVGIcons2["ic_broadcast"] = "SvgBroadcast";
  SVGIcons2["videoFullScreen"] = "VideoFullScreen";
  SVGIcons2["videoNormalScreen"] = "VideoFullScreen";
  SVGIcons2["videoVolume"] = "VideoVolume";
  SVGIcons2["videoVolumeOff"] = "VideoVolumeOff";
  SVGIcons2["videoPlay"] = "VideoPlay";
  SVGIcons2["videoPause"] = "VideoPause";
  SVGIcons2["pictureInPicture"] = "PictureInPicture";
  SVGIcons2["iconEdit"] = "IconEdit";
  SVGIcons2["iconLimits"] = "IconLimits";
  SVGIcons2["soccer"] = "Soccer";
  SVGIcons2["liveIcon"] = "IconLive";
  SVGIcons2["matchStopped"] = "MatchStopped";
  SVGIcons2["liveTimer"] = "LiveTimer";
  SVGIcons2["card_game"] = "CardGame";
  SVGIcons2["ic_logout"] = "SvgLogout";
  SVGIcons2["cup"] = "Cup";
  SVGIcons2["royal"] = "Royal";
  SVGIcons2["liveSport"] = "Timer";
  SVGIcons2["leaderboard"] = "Leaderboard";
  SVGIcons2["promotion"] = "Gift";
  SVGIcons2["result"] = "Finish";
  SVGIcons2["forecast"] = "Forecast";
  SVGIcons2["timer"] = "Timer";
  SVGIcons2["euro_banner"] = "SvgEuro2020";
  SVGIcons2["ic_aviator"] = "SvgAviator";
  SVGIcons2["ic_aviator_proppeller"] = "SvgAviatorProppeller";
  SVGIcons2["ic_aviator_full"] = "SvgAviatorFull";
  SVGIcons2["ic_aviator_title"] = "SvgAviatorText";
  SVGIcons2["hallOfFame"] = "HallOfFame";
  SVGIcons2["smartId"] = "SmartId";
  SVGIcons2["mobileId"] = "MobileId";
  SVGIcons2["timesCircle"] = "TimesCircle";
  SVGIcons2["checkCircle"] = "CheckCircle";
  SVGIcons2["check"] = "Check";
  SVGIcons2["pauseCircle"] = "PauseCircle";
  SVGIcons2["vip_diamond"] = "VipDiamond";
  SVGIcons2["winter"] = "Winter";
  SVGIcons2["WinterThree"] = "WinterThree";
  SVGIcons2["crashGame"] = "CrashGame";
  SVGIcons2["headerClock"] = "HeaderClock";
  SVGIcons2["breadCrumbsHome"] = "BreadcrumbsHome";
  SVGIcons2["reportIcon"] = "ReportIcon";
  SVGIcons2["verificationWarning"] = "VerificationWarning";
  SVGIcons2["verificationCheck"] = "VerificationCheck";
  SVGIcons2["cashierArrowLeft"] = "CashierArrowLeft";
  SVGIcons2["cashierArrowRight"] = "CashierArrowRight";
  SVGIcons2["filter"] = "Filter";
  SVGIcons2["timer_new"] = "TimerNew";
  SVGIcons2["modernSearch"] = "ModernSearch";
  SVGIcons2["modernTop"] = "ModernTop";
  SVGIcons2["modernTopEvents"] = "ModernTopEvents";
  SVGIcons2["modernLeagues"] = "ModernLeagues";
  SVGIcons2["modernTimer"] = "ModernTimer";
  SVGIcons2["modernSport"] = "ModernSport";
  SVGIcons2["modernCog"] = "ModernCog";
  SVGIcons2["modernAllSports"] = "ModernAllSports";
  SVGIcons2["modernAllSportsFilter"] = "ModernAllSportsFilter";
  SVGIcons2["modernTime"] = "ModernTime";
  SVGIcons2["modernAnalyticsBars"] = "ModernAnalyticsBars";
  SVGIcons2["modernBroadcast"] = "ModernBroadcast";
  SVGIcons2["modernScoreboard"] = "ModernScoreboard";
  SVGIcons2["modernCollapse"] = "ModernCollapse";
  SVGIcons2["modernFactorStats"] = "ModernFactorStats";
  SVGIcons2["modernLoader"] = "ModernLoader";
  SVGIcons2["analytics_market_item"] = "AnalyticsMarketItem";
  SVGIcons2["modernClose"] = "ModernClose";
  SVGIcons2["searchNoResults"] = "SearchNoResults";
  SVGIcons2["attention_triangle"] = "AttentionTriangle";
  SVGIcons2["qatar"] = "SvgQatar";
  SVGIcons2["ontarioRegSuccessNotification"] = "OntarioRegSuccessNotification";
  SVGIcons2["ontarioRegSuccessNotificationPurple"] = "OntarioRegSuccessNotificationPurple";
  SVGIcons2["fishing"] = "Fishing";
  SVGIcons2["kenoLotto"] = "SvgKenoLotto";
  SVGIcons2["EparakstsLogo"] = "EparakstsLogo";
  SVGIcons2["shareIcon"] = "SvgShare";
  SVGIcons2["shareSecondaryIcon"] = "SvgShareSecondary";
  SVGIcons2["successTickIcon"] = "SvgSuccessTick";
  SVGIcons2["SocialFacebook"] = "SocialFacebook";
  SVGIcons2["SocialGoogle"] = "SocialGoogle";
  SVGIcons2["socialWhatsappIcon"] = "SocialWhatsapp";
  SVGIcons2["socialTelegramIcon"] = "SocialTelegram";
  SVGIcons2["socialTwitterIcon"] = "SocialTwitter";
  SVGIcons2["SocialWhatsappNew"] = "SocialWhatsappNew";
  SVGIcons2["SocialTelegrammNew"] = "SocialTelegrammNew";
  SVGIcons2["SocialX"] = "SocialX";
  SVGIcons2["threeDotsIcon"] = "SvgThreeDots";
  SVGIcons2["copyIcon"] = "SvgCopy";
  SVGIcons2["CopyIconDark"] = "CopyIconDark";
  SVGIcons2["lastPage"] = "SvgLastPage";
  SVGIcons2["copyFilledIcon"] = "SvgCopyFilled";
  SVGIcons2["HorseRacing"] = "HorseRacing";
  SVGIcons2["ipl"] = "Ipl";
  SVGIcons2["virtualSports"] = "VirtualSports";
  SVGIcons2["vr"] = "Vr";
  SVGIcons2["ResponsibleGamblingDeactivation"] = "ResponsibleGamblingDeactivation";
  SVGIcons2["ResponsibleGamblingExclusion"] = "ResponsibleGamblingExclusion";
  SVGIcons2["ResponsibleGamblingLimits"] = "ResponsibleGamblingLimits";
  SVGIcons2["ResponsibleGamblingCoolingOff"] = "ResponsibleGamblingCoolingOff";
  SVGIcons2["playIcon"] = "ButtonPlay";
  SVGIcons2["boostedOdd"] = "BoostedOddIcon";
  SVGIcons2["PromotionsRiskFreebet"] = "PromotionsRiskFreebet";
  SVGIcons2["arrowCircle"] = "SvgArrowCircle";
  SVGIcons2["Partnership"] = "Partnership";
  SVGIcons2["fileUpload"] = "FileUpload";
  SVGIcons2["incomingBet"] = "IncomingBet";
  SVGIcons2["incomingBets"] = "IncomingBets";
  SVGIcons2["returnBet"] = "ReturnCircle";
  SVGIcons2["copyBetToCoupon"] = "CopyToCoupon";
  SVGIcons2["сopyBetToCouponSuccess"] = "CopyToCouponSuccess";
  SVGIcons2["copyBetToCouponMobile"] = "CopyToCouponMobile";
  SVGIcons2["updateIcon"] = "UpdateIcon";
  SVGIcons2["hiddenIcon"] = "SvgHidden";
  SVGIcons2["report_icon"] = "ReportsIcon";
  SVGIcons2["triangleWarning"] = "TriangleWarning";
  SVGIcons2["betbuilderMarketItem"] = "BetbuilderMarketItem";
  SVGIcons2["newSearchNoResults"] = "NewSearchNoResults";
  SVGIcons2["Checklist"] = "Checklist";
  SVGIcons2["vipHorse"] = "VipHorse";
  SVGIcons2["promoCasinoIcon"] = "PromoCasinoIcon";
  SVGIcons2["promoSport"] = "PromoSport";
  SVGIcons2["promoVip"] = "PromoVip";
  SVGIcons2["reportPie"] = "ReportPie";
  SVGIcons2["casinoGameOnlinePlayers"] = "SvgOnlinePlayersIcon";
  SVGIcons2["olympics"] = "Olympics";
  SVGIcons2["addUser"] = "AddUser";
  SVGIcons2["analyticsBarsReferrals"] = "AnalyticsBarsReferrals";
  SVGIcons2["bag"] = "Bag";
  SVGIcons2["checkUser"] = "CheckUser";
  SVGIcons2["click"] = "Click";
  SVGIcons2["giftBox"] = "GiftBox";
  SVGIcons2["coins"] = "Coins";
  SVGIcons2["esports"] = "Esports";
  SVGIcons2["sportbookmakers"] = "SportBookmakers";
  SVGIcons2["bonusHubInfo"] = "BonusHubInfo";
  SVGIcons2["bonusHubClock"] = "BonusHubClock";
  SVGIcons2["bonusHubLock"] = "BonusHubLock";
  SVGIcons2["activeWithdrawalTimer"] = "ActiveWithdrawalTimer";
  SVGIcons2["SvgAZIcon"] = "SvgAZIcon";
  SVGIcons2["SvgMoneyBagDollar"] = "SvgMoneyBagDollar";
  SVGIcons2["SvgNEW"] = "SvgNEW";
  SVGIcons2["SvgPopularityGrowth"] = "SvgPopularityGrowth";
  return SVGIcons2;
})(SVGIcons || {});
var svgIds = /* @__PURE__ */ ((svgIds2) => {
  svgIds2["SvgArrow"] = "svg-arrow";
  svgIds2["SvgLook"] = "svg-look";
  svgIds2["ButtonPlay"] = "button-play";
  svgIds2["Star"] = "star";
  svgIds2["SvgClose"] = "svg-close";
  svgIds2["Pin"] = "pin";
  svgIds2["InfoCircle"] = "info-circle";
  return svgIds2;
})(svgIds || {});
export {
  SVGIcons,
  svgIds
};
